var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyState2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 120,
    viewBox: "0 0 122 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.31055,
    width: 120,
    height: 120,
    rx: 60,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6757 41.2893C26.4478 44.1705 24.0964 47.304 20.4237 48.2881C19.5056 48.5341 18.5918 48.6225 17.7255 48.5716",
    stroke: "#A4A4A4",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0898 65.2268C32.8618 68.108 30.5105 71.2415 26.8378 72.2256C25.9196 72.4716 25.0058 72.56 24.1396 72.5091",
    stroke: "#A4A4A4",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5038 89.1643C39.2759 92.0455 36.9245 95.179 33.2519 96.1631C32.3337 96.4091 31.4199 96.4975 30.5537 96.4466",
    stroke: "#A4A4A4",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9021 17.876L29.5584 31.3656C26.9686 32.0595 25.4317 34.7215 26.1256 37.3113L43.6598 102.75C44.3537 105.339 47.0157 106.876 49.6055 106.182L99.9492 92.6929C102.539 91.9989 104.076 89.337 103.382 86.7472L85.8478 21.3088C85.1539 18.719 82.4919 17.1821 79.9021 17.876Z",
    fill: "#EBEBEB",
    stroke: "#A4A4A4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0799 13.4766L19.7361 26.9662C17.1463 27.6601 15.6094 30.3221 16.3034 32.9119L33.8375 98.3503C34.5314 100.94 37.1934 102.477 39.7832 101.783L90.127 88.2935C92.7168 87.5995 94.2537 84.9375 93.5597 82.3477L76.0256 16.9094C75.3316 14.3196 72.6697 12.7827 70.0799 13.4766Z",
    fill: "white",
    stroke: "#A4A4A4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7258 48.5714C15.1269 48.419 12.9554 47.0136 12.3764 44.8527C11.6044 41.9715 13.9557 38.838 17.6284 37.8539C21.301 36.8698 24.9041 38.4078 25.6761 41.2891",
    stroke: "#A4A4A4",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1399 72.5089C21.541 72.3565 19.3695 70.9511 18.7905 68.7902C18.0184 65.909 20.3698 62.7755 24.0424 61.7914C27.7151 60.8073 31.3182 62.3453 32.0902 65.2266",
    stroke: "#A4A4A4",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5539 96.4464C27.955 96.294 25.7835 94.8886 25.2045 92.7277C24.4325 89.8465 26.7838 86.713 30.4565 85.7289C34.1292 84.7448 37.7322 86.2828 38.5042 89.1641",
    stroke: "#A4A4A4",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4436 46.7653C45.7727 45.6053 48.3418 41.1555 47.1818 36.8264C46.0218 32.4972 41.572 29.9281 37.2429 31.0881C32.9138 32.2481 30.3447 36.6979 31.5046 41.0271C32.6646 45.3562 37.1144 47.9253 41.4436 46.7653Z",
    fill: "white",
    stroke: "#A4A4A4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6528 43.5003C37.6528 43.5003 38.0548 42.0703 40.044 41.5373C42.0333 41.0043 43.0964 42.0417 43.0964 42.0417",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6528 43.5003C37.6528 43.5003 38.0548 42.0703 40.044 41.5373C42.0333 41.0043 43.0964 42.0417 43.0964 42.0417",
    stroke: "#A4A4A4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1529 39.2097C36.7802 39.0416 37.1525 38.3967 36.9844 37.7694C36.8163 37.142 36.1715 36.7697 35.5441 36.9378C34.9168 37.1059 34.5445 37.7508 34.7126 38.3781C34.8807 39.0055 35.5255 39.3778 36.1529 39.2097Z",
    fill: "#A4A4A4",
    stroke: "#A4A4A4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2486 37.5769C42.8759 37.4088 43.2482 36.7639 43.0801 36.1366C42.912 35.5092 42.2672 35.1369 41.6398 35.305C41.0125 35.4731 40.6402 36.1179 40.8083 36.7453C40.9764 37.3727 41.6212 37.745 42.2486 37.5769Z",
    fill: "#A4A4A4",
    stroke: "#A4A4A4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M52.885 89.4616C57.2141 88.3016 59.7832 83.8518 58.6232 79.5227C57.4633 75.1935 53.0134 72.6244 48.6843 73.7844C44.3552 74.9444 41.7861 79.3942 42.946 83.7234C44.106 88.0525 48.5559 90.6216 52.885 89.4616Z",
    fill: "white",
    stroke: "#A4A4A4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7617 84.9629C48.7617 84.9629 49.8248 86.0003 51.8141 85.4673C53.8033 84.9343 54.2052 83.5043 54.2052 83.5043",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7617 84.9629C48.7617 84.9629 49.8248 86.0003 51.8141 85.4673C53.8033 84.9343 54.2052 83.5043 54.2052 83.5043",
    stroke: "#A4A4A4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5943 81.906C48.2216 81.7379 48.5939 81.093 48.4258 80.4657C48.2577 79.8383 47.6129 79.466 46.9855 79.6341C46.3582 79.8022 45.9859 80.447 46.154 81.0744C46.3221 81.7018 46.9669 82.0741 47.5943 81.906Z",
    fill: "#A4A4A4",
    stroke: "#A4A4A4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M53.688 80.2731C54.3154 80.105 54.6877 79.4602 54.5196 78.8328C54.3515 78.2055 53.7066 77.8332 53.0793 78.0013C52.4519 78.1694 52.0796 78.8142 52.2477 79.4416C52.4158 80.0689 53.0607 80.4412 53.688 80.2731Z",
    fill: "#A4A4A4",
    stroke: "#A4A4A4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9983 67.4968C51.3274 66.3368 53.8965 61.887 52.7365 57.5578C51.5765 53.2287 47.1267 50.6596 42.7976 51.8196C38.4684 52.9796 35.8993 57.4294 37.0593 61.7585C38.2193 66.0877 42.6691 68.6568 46.9983 67.4968Z",
    fill: "white",
    stroke: "#A4A4A4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7076 59.9411C42.3349 59.773 42.7072 59.1282 42.5391 58.5008C42.371 57.8735 41.7262 57.5012 41.0988 57.6693C40.4715 57.8374 40.0992 58.4822 40.2673 59.1096C40.4354 59.7369 41.0802 60.1092 41.7076 59.9411Z",
    fill: "#A4A4A4",
    stroke: "#A4A4A4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8033 58.3073C48.4306 58.1392 48.8029 57.4944 48.6348 56.867C48.4667 56.2397 47.8219 55.8674 47.1945 56.0355C46.5672 56.2036 46.1949 56.8484 46.363 57.4758C46.5311 58.1031 47.1759 58.4754 47.8033 58.3073Z",
    fill: "#A4A4A4",
    stroke: "#A4A4A4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1035 63.458L48.3526 62.0515",
    stroke: "#A4A4A4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1435 27.9351L51.5022 32.6621C51.0533 32.7824 50.787 33.2438 50.9072 33.6927L51.5974 36.2685C51.7177 36.7173 52.1791 36.9837 52.628 36.8635L70.2692 32.1365C70.7181 32.0162 70.9845 31.5548 70.8642 31.1059L70.174 28.5301C70.0537 28.0813 69.5923 27.8149 69.1435 27.9351Z",
    fill: "#EBEBEB"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8876 49.3707L57.2464 54.0976C56.7975 54.2179 56.5311 54.6793 56.6514 55.1282L57.3416 57.704C57.4618 58.1529 57.9232 58.4193 58.3721 58.299L76.0134 53.572C76.4622 53.4518 76.7286 52.9904 76.6083 52.5415L75.9182 49.9657C75.7979 49.5168 75.3365 49.2504 74.8876 49.3707Z",
    fill: "#EBEBEB"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6317 70.8072L62.9905 75.5342C62.5416 75.6544 62.2752 76.1158 62.3955 76.5647L63.0857 79.1405C63.206 79.5894 63.6674 79.8558 64.1163 79.7355L81.7575 75.0086C82.2064 74.8883 82.4728 74.4269 82.3525 73.978L81.6623 71.4022C81.542 70.9533 81.0806 70.6869 80.6317 70.8072Z",
    fill: "#EBEBEB"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6139 107.105L113.534 98.1939C113.629 98.1691 113.716 98.1402 113.804 98.1113C113.811 98.1154 113.816 98.1139 113.82 98.1069C113.929 98.0903 114.034 98.0625 114.14 98.0348C117.694 97.1011 119.815 93.4687 118.881 89.9145C118.315 87.7598 116.754 86.1336 114.819 85.3893C113.571 84.9097 112.161 84.8054 110.761 85.173L76.4775 89.3349C80.8179 88.9308 84.9302 91.7035 86.0725 96.0518C87.3417 100.883 84.451 105.834 79.6139 107.105Z",
    fill: "#D1D1D1",
    stroke: "#A4A4A4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9104 67.6468L68.5616 100.651C69.8308 105.483 74.7815 108.374 79.613 107.104C84.4501 105.834 87.3409 100.883 86.0717 96.0514C84.9294 91.7031 80.817 88.9304 76.4766 89.3345L110.76 85.1726C112.16 84.805 113.57 84.9093 114.818 85.3889L106.932 55.2944C106.3 52.8898 103.839 51.4526 101.439 52.0828L63.115 62.1506C60.7103 62.7823 59.2787 65.2421 59.9104 67.6468Z",
    fill: "#F5F5F5",
    stroke: "#A4A4A4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5938 62.1523L93.3513 71.0808",
    stroke: "#A4A4A4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5091 63.9961L100.438 69.2386",
    stroke: "#A4A4A4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9492 67.7832L71.7067 76.7116",
    stroke: "#A4A4A4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8645 69.626L78.793 74.8685",
    stroke: "#A4A4A4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M97.9121 77.6729L79.5408 82.4513",
    stroke: "#A4A4A4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M9.96828 72.1622C9.96828 72.1622 5.6125 77.2722 10.6902 81.6304C5.61241 77.2721 1.22201 82.3523 1.22201 82.3523C1.22201 82.3523 5.57778 77.2423 0.5 72.884C5.57778 77.2423 9.96828 72.1622 9.96828 72.1622Z",
    fill: "white",
    stroke: "#A4A4A4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M117.806 26.7569C117.806 26.7569 113.45 31.8669 118.528 36.2251C113.45 31.8668 109.06 36.947 109.06 36.947C109.06 36.947 113.416 31.837 108.338 27.4788C113.416 31.837 117.806 26.7569 117.806 26.7569Z",
    fill: "white",
    stroke: "#A4A4A4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyState2);
export default __webpack_public_path__ + "static/media/empty_state_2.ed4e76acb97134d4bc915fcd19d7509b.svg";
export { ForwardRef as ReactComponent };